"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DlgUploadProgress = /** @class */ (function (_super) {
    __extends(DlgUploadProgress, _super);
    function DlgUploadProgress(props) {
        return _super.call(this, props) || this;
    }
    DlgUploadProgress.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                progressTitle: data.progressTitle,
                progressText: data.progressText,
                errorTitle: data.errorTitle,
                errorText: data.errorText,
                displayMode: data.displayMode,
                progressPercent: data.progressPercent,
                isCanClose: data.isCanClose
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            progressTitle: this.props.controller.DATA.progressTitle,
            progressText: this.props.controller.DATA.progressText,
            errorTitle: this.props.controller.DATA.errorTitle,
            errorText: this.props.controller.DATA.errorText,
            displayMode: this.props.controller.DATA.displayMode,
            progressPercent: this.props.controller.DATA.progressPercent,
            isCanClose: this.props.controller.DATA.isCanClose
        });
    };
    DlgUploadProgress.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgUploadProgress.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgUploadProgress.prototype.getCloseButton = function () {
        if (this.state.isCanClose) {
            return (React.createElement(antd_1.Button, { type: "primary", onClick: this.handleClose.bind(this) }, "OK"));
        }
        else {
            return null;
        }
    };
    DlgUploadProgress.prototype.getErrorMessageDlg = function () {
        return (React.createElement(antd_1.Modal, { title: this.state.errorTitle, visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: false, maskClosable: false, footer: this.getCloseButton() },
            React.createElement("p", null, this.state.errorText)));
    };
    DlgUploadProgress.prototype.getProgressViewDlg = function () {
        return (React.createElement(antd_1.Modal, { title: React.createElement("div", { style: { textAlign: "center" } }, this.state.progressTitle), visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: false, maskClosable: false, footer: this.getCloseButton(), width: 280 },
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    width: "100%",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    justifyItems: "center"
                } },
                React.createElement("div", { style: { width: "120px", height: "120px", maxWidth: "120px", maxHeight: "120px" } },
                    React.createElement(antd_1.Progress, { type: "circle", percent: this.state.progressPercent })),
                React.createElement("div", { style: { width: "120px", maxWidth: "120px", textAlign: "center" } },
                    React.createElement("p", null, this.state.progressText)))));
    };
    DlgUploadProgress.prototype.getRenderObject = function () {
        if (this.state.displayMode === "progress") {
            return (this.getProgressViewDlg());
        }
        if (this.state.displayMode === "error") {
            return (this.getErrorMessageDlg());
        }
        return null;
    };
    DlgUploadProgress.prototype.render = function () {
        return (this.getRenderObject());
    };
    return DlgUploadProgress;
}(React.Component));
exports.default = DlgUploadProgress;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgUploadProgress.tsx
// module id = 2376
// module chunks = 0